import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Button} from "../../../components/Button/index";
import routeSettings from '../../../config/router';
import '../UserOrders.scss';

class OrdersList extends React.Component {

  static propTypes = {
    getUserOrders: PropTypes.func,
  };

  componentWillMount() {
    this.props.getUserOrders()
  }

  getCityName = (arr, id) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id === id) {
        return arr[i].city
      }
    }
    return '';
  };

  render() {

    const {
      orders,
      cities,
      history,
    } = this.props;
    return (
      <div className="user-order scroll">
        <h2 className="user-order__title">Order List</h2>
        {
          orders.length > 0 ?
            <div className="user-order__list">
              <ul className="user-order__list-titles">
                <li className="user-order__title-item user-order__title-number"><span>№</span></li>
                <li className="user-order__title-item"><span>Order data</span></li>
                <li className="user-order__title-item user-order__title-city"><span>City</span></li>
                <li className="user-order__title-item user-order__title-tour"><span>Tour link</span></li>
                {/* <li className="user-order__title-item"><span>Client name</span></li> */}
                <li className="user-order__title-item user-order__title-price"><span>Order price</span></li>
                <li className="user-order__title-item user-order__title-edit"><span className="not-font">1</span></li>
              </ul>
              <ul className="user-order__list-body">
                {
                  orders.map((o, index) => {
                    return (
                      <li
                        className="user-order__list-item"
                        key={`order-item-${o.id}`}
                      >
                        <p className="user-order__item-block user-order__item-number">
                          {index + 1}
                        </p>
                        <p className="user-order__item-block">
                          {moment(o.createdAt).locale('en').format('YYYY MMMM DD hh:mm')}
                        </p>
                        <p className="user-order__item-block user-order__item-city">
                          {this.getCityName(cities, o.cityId)}
                        </p>
                        <p className="user-order__item-block user-order__item-tour scroll">
                          {
                            o.products && o.products.length ? o.products.map((pr) => {
                              return (
                                <span
                                  key={`order-product-item-${pr.tour.id}`}
                                  onClick={() => history.push(`${routeSettings.tourPage}/${pr.tour.id}`)}
                                  role="presentation"
                                  onKeyDown={() => {
                                  }}
                                >
                                  {pr.tour.title}
                                </span>
                              )
                            }) : null
                          }
                        </p>
                        <p className="user-order__item-block">
                          $ {o.amount}
                        </p>
                        <p className="user-order__item-block user-order__item-edit">
                          <Button
                            name="View order"
                            onClick={() => history.push(`${routeSettings.orderDetails}/${o.id}`)}
                          />
                        </p>
                      </li>
                    )
                  })
                }
              </ul>
            </div> : null
        }
      </div>
    )
  }
}

OrdersList.propTypes = {
  orders: PropTypes.array,
  cities: PropTypes.array,
  history: PropTypes.object,
};

export default OrdersList


// WEBPACK FOOTER //
// ./src/app/containers/UserOrders/List/Component.js